<template>
  <v-col
    class="d-flex justify-end align-end flex-nowrap"
    :class="clase"
  >
    <v-btn
      title="Limpiar filtro"
      color="warning"
      class="mr-3"
      icon
      @click="$emit('clear')"
    >
      <v-icon>fas fa-broom</v-icon>
    </v-btn>
    <v-btn
      color="info"
      type="submit"
      tabindex="1"
      :disabled="disabled"
      :loading="loading"
    >
      <v-icon left>fas fa-search</v-icon>
      Buscar
    </v-btn>
  </v-col>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    // permite agregar un class extra a la fila del boton, por defecto es margin top: mt-4
    clase: {
      type: String,
      default: 'mt-4'
    }
  }
}
</script>